export default "__VITE_ASSET__C$26gegQ__"